import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// 初始化css
import '../public/css/public.css'
// Element-ui
import "@/plugins/element-ui"
import resetMessage from '@/assets/js/message'
Vue.prototype.$message = resetMessage;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
